// Team component
import React, { useState } from "react";
import NavBar from "../shared/NavBar";
import Footer from "../shared/Footer";
import '../../styles/team/Team.css';

const advisorsData = [
    {
        id: "Veyrl-Adell",
        image: "/images/team-images/Veyrl.png",
        name: "Veyrl Adell",
        position: "Founder",
        description: "Gender economist, driven by passion, committed to excellence and excited by positive change. Raised in rural Kenya; lived in India, Rwanda, Swaziland and Zambia. World thought leader, advisor, coach speaker."
    },
    {
        id: "Bwalya-Penza",
        image: "/images/team-images/Bwalya.png",
        name: "Bwalya Penza",
        position: "Advisor to the Founder",
        description: null
    },
    // {
    //     id: "Jackie-Ayiro",
    //     image: "/images/team-images/Jackie.png",
    //     name: "Jackie Ayiro",
    //     position: "Advisor - Trade & Youth",
    //     description: null 
    // }
];

const teamData = [
    {
        id: "Henry-Shoko",
        image: "/images/team-images/Henry.png",
        name: "Henry Shoko",
        position: "Group Managing Director - Africa",
        description: "Stemming from an International Business background, Henry leads the charge in our group corporate interactions. His “iron fist clad in a velvet glove” approach, ensures our B2B business is on an upward tangent as he perpetually strives for excellence in our delivery."
    },
    {
        id: "Joshua-Oseno",
        image: "/images/team-images/Joshua.png",
        name: "Joshua Oseno",
        position: "Group Chief Technical Officer",
        description: "10 years experience in Finance, Proficient in a range of Accounting Softwares and ERPs, Passionate about automation of processes for business efficiency and growth."
    },
    {
        id: "Die-Junior",
        image: "/images/team-images/Junior.png",
        name: "Die Junior",
        position: "Managing Director - West Africa",
        description: null
    },
    {
        id: "Simon-Muturi",
        image: "/images/team-images/Simon.png",
        name: "Simon Muturi",
        position: "Senior Software Developer",
        description: "A skilled software developer with prowess in solving real-world problems through coding. Has a deep commitment to innovation, and thrives on crafting efficient solutions using technology."
    },
    {
        id: "Chichi-Chona",
        image: "/images/team-images/Chichi.png",
        name: "Chichi Chona",
        position: "Digital Marketing Executive",
        description: null
    },
    {
        id: "David-Chikulu",
        image: "/images/team-images/David.png",
        name: "David Chikulu",
        position: "Digital Economy Specialist",
        description: null
    }
];

const consultantsData = [
    {
        id: "Christine-Arunga",
        image: "/images/team-images/christine.png",
        name: "Christine Arunga",
        position: "Head of Sales and Marketing",
        description: null
    },
    {
        id: "Caleb-Karimi",
        image: "/images/team-images/Caleb.png",
        name: "Caleb Karimi",
        position: "Software Developer",
        description: "Motivated and goal-oriented full-stack software developer with hands-on skills in designing and developing web applications. Passionate about creating and delivering dynamic, user-focused and impactful solutions."
    },
    {
        id: "Faith-Nabuchi",
        image: "/images/team-images/faith.png",
        name: "Faith Nabuchi",
        position: "Admin and Operations Officer",
        description: null
    }
];

const prevConsultantsData = [
    {
        id: "Michelle-Atieno", name: "Michelle Atieno", position: "Projects Officer",
    },
    {
        id: "Michelle-Ogonya", name: "Michelle Ogonya", position: "Assistant Projects Officer",
    },
    {
        id: "Michael-Lunensu", name: "Michael Lunensu", position: "Junior Sales Officer",
    },
    {
        id: "Menlyna-Mhango", name: "Menlyna M'hango", position: "Junior Sales Officer",
    },
    {
        id: "Kennedy-Njiru", name: "Kennedy Njiru", position: "Digital Market Agent",
    },
    {
        id: "Florence-Opiyo", name: "Florence Opiyo", position: "Digital Market Agent",
    }
];

const testimonialsData = [
    {
        id: "Lucky-Mutambo",
        image: "/images/lucky-600x600.jpg",
        name: "Lucky Mutambo",
        position: "Implementation Executive",
        quote: "Being an implementation executive at Siginifide is an opportunity I greatly appreciate . My understanding of accounting has grown though not only accounting as the Siginifide Enterprise Resources Software (Kindatech ERP ) is rich with other management softwares like HR, CRM, Payroll, School management software,Loan system etc. The Kindatech ERP is a software I would recommend for any business. You are able to manage any business, starting from managing human capital to financials, assets and liabilities, income and expenses. Additionally, as a junior consultant, I have found immense value in this role, gaining invaluable skills and seizing opportunities that contribute to both personal and professional growth. It’s a pathway that not only equips the youth with vital expertise but also fosters a dynamic environment for learning and advancement."
    },
    {
        id: "Salome-Githinji",
        image: "/images/salome-githinji.png",
        name: "Salome Githinji",
        position: "former Software Developer Intern",
        quote: "As a junior software developer at Signifide, We rely on the company’s ERP system built on the frappe framework to offer module services such as HR services ,payroll, Employee management services, Kindatech Education and many others. Signifide’s ERP system, built with the Frappe framework, has significantly improved by trying to increase other modules to serve businesses in Zambia and Kenya . Overall, Signifide’s ERP system has boosted our efficiency and visibility. I highly recommend it for businesses seeking a robust and customizable ERP solution."
    },
    {
        id: "Theresa-Zulu",
        image: "/images/theresa-zulu.jpg",
        name: "Theresa Zulu",
        position: "former Junior Consultant",
        quote: "My time as a Junior Consultant at Signifide has been transformative. Before this role, my understanding of e-commerce was limited to user experience. Now, I deeply appreciate the intricate work that goes into building and maintaining these platforms. This role has significantly enhanced my confidence and communication skills, particularly through client interactions and presentations. I've also gained valuable experience working with diverse industries and collaborating with a supportive team. The Junior Consultants Program offers an invaluable opportunity for professional and personal growth, and I highly recommend it to anyone considering it."
    }
];

// --- Reusable Component for Team Member Cards ---
function TeamMemberCard({ member, hoveredCardIndex, setHoveredCardIndex, cardClassName }) {
    return (
        <div className={cardClassName}>
            <div
                className={`card-image-container ${hoveredCardIndex === member.id && member.description ? "dimmed" : ""}`}
                onMouseEnter={() => setHoveredCardIndex(member.id)}
                onMouseLeave={() => setHoveredCardIndex(null)}
            >
                <img src={member.image} alt={member.name} loading="eager" />
                {member.description && hoveredCardIndex === member.id && (
                    <div className="card-description">
                        <p>{member.description}</p>
                    </div>
                )}
            </div>
            <h5>{member.name}</h5>
            <p>{member.position}</p>
        </div>
    );
}

// --- Reusable Component for Testimonial Cards ---
function TestimonialCard({ testimonial, alignmentClass }) {
    return (
        <div className={alignmentClass}>
            {alignmentClass === "testimonials-card-left-image" && <img src={testimonial.image} alt={testimonial.name} loading="lazy" />}
            <div className="testimonials-card-content">
                <p><span>"</span>{testimonial.quote}<span>"</span></p>
                <h5>- {testimonial.name}, {testimonial.position}</h5>
            </div>
            {alignmentClass === "testimonials-card-right-image" && <img src={testimonial.image} alt={testimonial.name} />}
        </div>
    );
}

// --- Main OurTeam Component ---
function OurTeam() {
    const [hoveredCardIndex, setHoveredCardIndex] = useState(null);

    return (
        <div className="our-team-component">
            <NavBar />
            <div className="our-team">
                <h1>Get to Know the <span>Team</span> Powering our Vision and Success</h1>

                {/* Board of Advisors Section */}
                <div className="board-of-advisors">
                    <h2>Meet the <span>Board Of Advisors</span></h2>
                    <p className="boa-description">Thoughtful, concise, structural and constructive leadership. </p>
                    <div className="advisors">
                        {advisorsData.map((advisor) => (
                            <TeamMemberCard
                                key={advisor.id}
                                member={advisor}
                                hoveredCardIndex={hoveredCardIndex}
                                setHoveredCardIndex={setHoveredCardIndex}
                                cardClassName="advisors-card"
                            />
                        ))}
                    </div>
                </div>

                {/* The Team Section */}
                <div className="the-team">
                    <h2>Meet the <span>Team</span></h2>
                    <div className="the-team-content">
                        {teamData.map((member) => (
                            <TeamMemberCard
                                key={member.id}
                                member={member}
                                hoveredCardIndex={hoveredCardIndex}
                                setHoveredCardIndex={setHoveredCardIndex}
                                cardClassName="the-team-card"
                            />
                        ))}
                    </div>
                </div>

                {/* Junior Consultants Section */}
                <div className="junior-consultants">
                    <h2>Meet the <span>Junior Consultants</span></h2>
                    <div className="junior-consultants-content">
                        {consultantsData.map((consultant) => (
                            <TeamMemberCard
                                key={consultant.id}
                                member={consultant}
                                hoveredCardIndex={hoveredCardIndex}
                                setHoveredCardIndex={setHoveredCardIndex}
                                cardClassName="junior-consultants-card"
                            />
                        ))}
                    </div>
                </div>

                {/* Team Testimonials Section */}
                <div className="testimonials">
                    <h2><span>Testimonials</span> from the Team</h2>
                    <div className="testimonials-content">
                        {testimonialsData.map((testimonial, index) => (
                            <TestimonialCard
                                key={testimonial.id}
                                testimonial={testimonial}
                                // Alternate alignment based on index for the desktop view
                                alignmentClass={index % 2 === 0 ? "testimonials-card-left-image" : "testimonials-card-right-image"}
                            />
                        ))}
                    </div>

                    {/* Testimonials for Mobile */}
                    <div className="testimonials-content-mobile">
                        {testimonialsData.map((testimonial) => (
                            <div className="testimonials-card-mobile" key={testimonial.id + "-mobile"}>
                                <img src={testimonial.image} alt={testimonial.name} />
                                <div className="testimonials-card-content-mobile">
                                    <p><span>"</span>{testimonial.quote}<span>"</span></p>
                                    <h5>- {testimonial.name}, {testimonial.position}</h5>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default OurTeam;